export default "__VITE_ASSET__65535f45__"